import { useQuery } from '@tanstack/react-query';

import { fetchMyWorkCount } from '@/api/work';
import { useAuth } from '@/auth/useAuth';

import { WORK_REFETCH_MS } from './useWork';
import { useWorkLive } from './useWorkLive';

/**
 * How much is waiting for the signed-in person, for the badge on Today.
 *
 * It also holds the work topic open, because the rail is on every page and a connection of its own
 * per page would be one connection too many. Nothing is returned until the count is known, and a
 * count that could not be read is not shown as zero.
 *
 * @returns the total, or undefined while it is unknown
 */
export function useTodayCount(): number | undefined {
  const { identity, user } = useAuth();
  useWorkLive(user?.tenantId, identity);
  const count = useQuery({
    queryKey: ['work', identity, 'count'],
    queryFn: fetchMyWorkCount,
    enabled: identity !== null,
    refetchInterval: WORK_REFETCH_MS,
    refetchOnWindowFocus: true,
    select: (data) => data.total,
  });
  return count.data;
}
